import { Dispatch, SetStateAction, useMemo, useState } from 'react'
import { useOffsetTop } from '@/hooks/useOffsetTop'
import { SchoolSummaryStatus } from '@/types/school'
import { isMobile } from 'react-device-detect'

export const useSchool = (
  status?: SchoolSummaryStatus,
  ref?: React.RefObject<HTMLDivElement>
): [boolean, Dispatch<SetStateAction<boolean>>] => {
  // スクロール量の調整。おすすめポイントまでの高さの半分からヘッダーの高さを引く
  const adjustHeight = isMobile ? 445 / 2 - 50 : 667 / 2 - 103
  const [finish, setFinish] = useState(status?.isComplete)
  const [surveyOpen, setSurveyOpen] = useState<boolean>(false)
  const { pageOffsetTop, viewportTop } = useOffsetTop(ref)

  useMemo(() => {
    // スクール経由ではない場合
    if (!status?.fromSchool) return
    // 振り返りモーダルを開き済みの場合
    if (finish) return
    // 位置を取得できなかった場合は読了率を0とする
    if (pageOffsetTop === undefined || viewportTop === undefined) {
      return
    }
    // 振り返りモーダルの表示位置までの到達率
    const now = 100 - (viewportTop / (pageOffsetTop - adjustHeight)) * 100
    // 振り返りモーダルを表示する
    if (now >= 100) {
      setFinish(true)
      setSurveyOpen(true)
      return
    }
  }, [pageOffsetTop, viewportTop])
  return [surveyOpen, setSurveyOpen]
}
